import React, { useState, useEffect, useRef,useCallback } from "react";
import apiClient from "../../../api/apiClient";
import EXIF from 'exif-js';
import { publish, subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { Form, Button, Row, Col, Badge, Alert, Spinner } from "react-bootstrap";
import { Input, AlertMassage, PopupModel } from "../../shared";
import CourseVideoList from './CourseVideoList';
import CourseQuestionList from './CourseQuestionList';
import RefrenceList from './RefrenceList';
import { PaperclipIcon, BackArrowIcon } from "../../../utils/FontIcon";
import { useNavigate } from 'react-router-dom';
import { PlusIcon } from "../../../utils/FontIcon";
import { levelConfig, getSession, setSession,categary } from "../../../utils/utils";
import { GETCOURSELIST } from '../../../utils/ApiEndPoint';

export default function CreateCourse({ levels }) {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        title: "",
        tags: "",
        description: "",
        skillLevel: levels.courseLevel || '',
        goals: "",
        targetAudience: "",
        thumbnail: null,
        category: ''
    });
    const [lesson, setLesson] = useState([]);
    const [errors, setErrors] = useState({});
    const [reset, setReset] = useState(false);
    const [showAlert, setShowAlert] = useState({
        type: '',
        title: '',
        msg: ``,
        show: false
    })
    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        type: '',
        selectedItem: [],
    });
    const [isEditMode, setIsEditMode] = useState({ mode: false, id: '', createdBy: '', updatedBy: '' });
    const [imageMetadata, setImageMetadata] = useState({});
    const thumInputRef = useRef(null);
    const [waitForResponse, setWaitForResponse] = useState(false);
    useEffect(() => {
        const pubsubToken = subscribe('EDIT_COURSE', (course) => {
            const modules = typeof course.modules === "string" ? JSON.parse(course.modules) : [];
            const lesson = modules.length && typeof modules[0].lessons === "string" ? JSON.parse(modules[0].lessons) : [];
            setLesson(lesson);
            setForm({
                title: course?.title || '',
                tags: course?.tags?.join(),
                description: course?.description || '',
                skillLevel: course?.skillLevel || '',
                goals: course?.goals || '',
                targetAudience: course?.targetAudience || '',
                category: course?.category || '',
            });
            setErrors({});
            setReset(false);
            setImageMetadata({})
            publish('SELECTED_VIDEO', lesson.filter(item => item.type === 'video'));
            publish('SELECTED_QUESTION', lesson.filter(item => item.type === 'quiz'));
            setIsEditMode({ mode: true, id: course._id, createdBy: course.createdBy, updatedBy: course.updatedBy });
        });
        return () => unsubscribe(pubsubToken);
    }, []);

    useEffect(() => {
        const addItem = subscribe('ADD_ITEM', (item) => {
            setLesson((prev) => [...prev, item]);
            setErrors((prev) => ({ ...prev, ['lesson']: '' }));
        });
        return () => unsubscribe(addItem);
    }, []);
    useEffect(() => {
        const removeItem = subscribe('REMOVE_ITEM', (item) => {
            setLesson((prev) => prev.filter((lesson) => lesson.refId !== item._id));
        });
        return () => unsubscribe(removeItem);
    }, []);

    const handleChange = useCallback((e) => {
        const { name, value, files } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: files ? files[0] : value,
        }));
        if (name === 'skillLevel') {
            const courseLevels = getSession('levelForm');
            setSession('levelForm', {
                ...courseLevels,
                courseLevel: value
            });
        }

        if (files) {
            const file = files[0];
            const basicMeta = {
                name: file.name,
                size: (file.size / 1024 / 1024).toFixed(2),
                type: file.type,
                lastModified: new Date(file.lastModified).toLocaleString(),
            };
            if (file.type.startsWith('image/')) {
                extractImageMetadata(file, basicMeta);
            }
        }
        setErrors((prev) => ({ ...prev, [name]: undefined }));
    },[]);
    const extractImageMetadata = useCallback((file, basicMeta) => {
        const reader = new FileReader();
        reader.onload = function (e) {
            EXIF.getData(file, function () {
                const allMetaData = EXIF.getAllTags(this);
                setImageMetadata({ ...basicMeta, ...allMetaData });
            });
        };
        reader.readAsArrayBuffer(file);
    },[]);
    const validate = () => {
        const newErrors = {};
        if (!form?.title?.trim()) newErrors.title = "Title is required";
        if (!form?.tags?.trim()) newErrors.tags = "Keywords are required";
        if (!form?.skillLevel?.trim()) newErrors.skillLevel = "Difficulty level is required";
        if (!form?.category?.trim()) newErrors.category = "Category is required";
        if (!form?.description?.trim()) newErrors.description = "Description is required";
        if (lesson?.length === 0) newErrors.lesson = "At least one video and one assessment are required";
        if (lesson?.length) {
            const hasVideo = lesson.some(item => item.type === 'video');
            const hasQuiz = lesson.some(item => item.type === 'quiz');
            if (!hasVideo) newErrors.lesson = "At least one video is required";
            if (!hasQuiz) newErrors.lesson = "At least one assessment is required";
        }
        if (!form.thumbnail) newErrors.thumbnail = "Thumbnail is required";
        else if (form.thumbnail && !isEditMode.mode && imageMetadata.size > 5) newErrors.thumbnail = "Iamge Size must be less then 5 mb";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (!validationErrors) {
            return;
        }
        setWaitForResponse(true);
        !isEditMode.mode ? savedata() : saveEdited();
    };
    const savedata = () => {
        const modules = [{ 'title': form.title, 'lessons': JSON.stringify(lesson) }]
        const data = new FormData();
        Object.keys(form).forEach(key => data.append(key, form[key]));

        data.append('modules', JSON.stringify(modules));
        let tempAlert = {
            type: 'danger',
            title: 'Error',
            msg: '',
            show: true
        }
        apiClient.post(GETCOURSELIST, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress: (progressEvent) => {
                const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                // setProgress(percent);
            }
        }).then((response) => {
            if (response.status === 201) {
                resetForm();
                tempAlert.type = 'success';
                tempAlert.title = 'Success';
                tempAlert.msg = (<><p>✅ Course created successfully!</p><Alert.Link className='float-end' onClick={() => {
                    navigate(`/viewcourses/${response?.data?._id}`);
                }}>View Course</Alert.Link></>);
                publish('FETCH_COURSE');
            } else {
                tempAlert.msg = '❌ Course creation failed.';
            }
        }).catch((error) => {
            tempAlert.msg = '❌ Course creation failed.';
        }).finally(() => {
            setWaitForResponse(false);
            setShowAlert(tempAlert);
        });
    }
    const saveEdited = async () => {
        const data = {
            "title": form.title,
            "tags": form.tags,
            "description": form.description,
            "skillLevel": form.skillLevel,
            "goals": form.goals,
            "targetAudience": form.targetAudience,
            "modules": JSON.stringify([{ 'title': form.title, 'lessons': JSON.stringify(lesson) }]),
            "createdBy": isEditMode.createdBy,
            "updatedBy": "665a2bb1d2fe3a22ec8d3b12"
        }

        let tempAlert = {
            type: 'danger',
            title: 'Error',
            msg: '',
            show: true
        }
        apiClient.put(`${GETCOURSELIST}/${isEditMode.id}`, data)
            .then((response) => {
                if (response.status === 200) {
                    resetForm();
                    tempAlert.type = 'success';
                    tempAlert.title = 'Success';
                    tempAlert.msg = (<><p>✅ Course updated successfully!</p><Alert.Link className='float-end' onClick={() => {
                        navigate(`/viewcourses/${response?.data?._id}`);
                    }}>View Course</Alert.Link></>);
                    publish('FETCH_COURSE');
                } else {
                    tempAlert.msg = '❌ Course updated failed.';
                }
            }).catch((error) => {
                tempAlert.msg = '❌ Course updated failed.';
            }).finally(() => {
                setShowAlert(tempAlert);
                setWaitForResponse(false);
            });
    }
    const resetForm = () => {
        setForm({
            title: "",
            tags: "",
            description: "",
            skillLevel: '',
            goals: "",
            targetAudience: "",
            category: '',
            // thumbnail:null
            // modules: []
        });

        setIsEditMode({
            mode: false,
            id: '',
            createdBy: '',
            updatedBy: ''
        });
        setLesson([]);
        setReset(true);
        setImageMetadata({});
        setErrors({});
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        });
        if (thumInputRef.current) {
            thumInputRef.current.value = '';
        }
    }
    const hideAlert = () => {
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        })
    }

    const onHandelRefrenceList = () => {
        const selectedItem = lesson.filter(item => item.type === 'ref_doc');
        setPopupData({
            show: true,
            title: 'Refrence List',
            type: 'refrence',
            selectedItem: selectedItem,
        })
    };
    const handleCloseModal = () => {
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: [],
        })
    };
    const handelSave = (selectedDocumentList) => {
        handleCloseModal();
        const existingLessons = lesson.filter(item => item.type !== 'ref_doc');
        const newRefs = selectedDocumentList.map(item => ({
            type: 'ref_doc',
            refId: item._id ? item._id : item.refId,
            titleOverride: item.title,
            documentUrl: item.documentUrl,
        }));
        const updatedLesson = [...existingLessons, ...newRefs];
        setLesson(updatedLesson);
    }
    const handelAddRefrence = () => {
        navigate('/addmanageresource')
    }
    const refDoclength = lesson.filter(item => item.type === 'ref_doc').length;
    const handelGotoDashboard = () => {
        navigate('/home');
    }
    
    return (
        <Col lg={12} className="add-video-bg" >
            <Row>
                <Col xs={12} lg={10} md={8}>
                    <h4 className="mb-0 fw-bold">Add & Manage Course</h4>
                    <div className="mb-2 ms-1 small fw-semibold text-secondary">(Add course)</div>
                </Col>
                <Col xs={12} lg={2} md={4} className="text-end">
                    <Button variant="outline-dark" onClick={handelGotoDashboard} title="Go to dashboard"><BackArrowIcon /> Go to dashboard</Button>
                </Col>
            </Row>
            <Row>
                <div className="add-video-container">
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            {/* <Col lg={12}> <div className="mb-2 fw-700 fs-8 onemb-3 fs-8 onerem">Building your new course</div></Col> */}
                            <Col lg={8} md={12} style={{ borderRight: "1px solid #dee2e6", paddingRight: '1.25rem' }}>
                                <Row>
                                    <Col xs={12} md={6}>
                                        <CourseVideoList reset={reset} level={levels?.videoLevel || ''} />
                                    </Col>
                                    <Col xs={12} md={6}>
                                        <CourseQuestionList reset={reset} level={levels?.questionLevel || ''} />
                                    </Col>
                                    <Col md={12} className="pt-3">
                                        {errors.lesson ?
                                            <Alert variant='danger' className="mt-4">
                                                {errors.lesson}
                                            </Alert> : null}
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={4} md={12} className="d-flex course-desc-box" style={{ paddingLeft: '1.25rem' }}>
                                <Row>
                                    <Row className="pe-0">
                                        <Col xs={6} lg={6}>
                                            <div className="mb-3 fw-semibold fs-8 "><h6>Course Description</h6>
                                            </div>
                                        </Col>
                                        <Col xs={6} md={6} className="pe-0">
                                            <Button variant="outline-dark" className='addbtn-small fright' onClick={handelAddRefrence} title="+ Add Reference"><PlusIcon style={{ fontSize: '10px' }} /> Add Reference</Button>
                                        </Col>
                                    </Row>
                                    <Col md={5} className="mt-1">
                                        <Input
                                            label="Difficulty level"
                                            type="select"
                                            name="skillLevel"
                                            value={form.skillLevel}
                                            onChange={handleChange}
                                            isInvalid={!!errors.skillLevel}
                                            feedback={errors.skillLevel}
                                            multiple={false}
                                            options={levelConfig}
                                            isMandetory={true}
                                            inlineFeedback={true}
                                        />
                                    </Col>
                                    <Col md={7} className="mt-1">
                                        <Input
                                            label="Category"
                                            type="select"
                                            name="category"
                                            value={form.category}
                                            onChange={handleChange}
                                            isInvalid={!!errors.category}
                                            feedback={errors.category}
                                            multiple={false}
                                            options={categary}
                                            isMandetory={true}
                                            inlineFeedback={true}
                                        />
                                    </Col>
                                    <Col md={12} >
                                        <Input
                                            label="Title"
                                            isMandetory={true}
                                            name="title"
                                            value={form.title}
                                            onChange={handleChange}
                                            placeholder="enter your course title"
                                            isInvalid={!!errors.title}
                                            feedback={errors.title}
                                            // helperText="80 words"
                                            maxLength={200}
                                            inlineFeedback={true}
                                        />
                                    </Col>
                                    <Col md={12}>
                                        <Input
                                            label="Keywords"
                                            isMandetory={true}
                                            name="tags"
                                            value={form.tags}
                                            onChange={handleChange}
                                            placeholder="enter keywords"
                                            isInvalid={!!errors.tags}
                                            feedback={errors.tags}
                                            // helperText="use comma-separated value"
                                            inlineFeedback={true}

                                        />
                                    </Col>

                                    <Col md={12}>
                                        <Input
                                            label="Description"
                                            isMandetory={true}
                                            name="description"
                                            value={form.description}
                                            onChange={handleChange}
                                            placeholder="enter description"
                                            isInvalid={!!errors.description}
                                            feedback={errors.description}
                                            as="textarea"
                                            rows={4}
                                            maxLength={500}
                                            inlineFeedback={true}
                                        />
                                    </Col>

                                    <Col md={12}>
                                        <Button variant="outline-success" type="button" title="Attach Reference" className="add-reference-btn btn btn-outline-secondary btn-sm mbtm8" onClick={onHandelRefrenceList} ><PaperclipIcon />{refDoclength ? <>Manage Reference <Badge bg="secondary">{refDoclength}</Badge> </> : ' Attach Reference'} </Button>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="fs-8">
                                                <span className="d-block fw-600">Upload Thumbnail  <span style={{ color: 'red' }}>*</span></span>
                                                <small className="fw-semibold">(supported formats: jpeg, png)  | (Max Size : 5MB)</small>

                                            </Form.Label>
                                            <div className="d-flex align-items-center gap-2">
                                                <Form.Control
                                                    type="file"
                                                    name="thumbnail"
                                                    onChange={handleChange}
                                                    style={{ fontSize: '0.8rem', lineHeight: '2.4', color: '#999', minHeight: '33px' }}
                                                    className={!!errors.thumbnail ? 'invalidinput' : ''}
                                                    accept=".jpeg,.jpg,.png"
                                                    ref={thumInputRef}
                                                />
                                            </div>
                                            {errors.thumbnail ?
                                                <Form.Control.Feedback type="invalid" className="d-block">{errors.thumbnail}</Form.Control.Feedback>
                                                :
                                                <Form.Text>
                                                    <div className={imageMetadata.size ? "hinttxt" : ''} style={{ minHeight: '20px' }}>{imageMetadata.size && <span><strong>Size:</strong> {imageMetadata.size} MB</span>}</div>
                                                </Form.Text>
                                            }
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <div className="d-flex gap-3 justify-content-end">
                                <Button variant="outline-secondary" title="Reset" type="button" className="px-4" disabled={waitForResponse} onClick={resetForm}>
                                    Reset
                                </Button>

                                <Button type="submit" title="Save" className="save-btn px-5" disabled={waitForResponse}>
                                    {isEditMode.mode ? 'Update' : 'Save'}
                                </Button>

                            </div>
                        </Row>
                    </Form>
                </div>
            </Row>
            {showAlert.show &&
                <AlertMassage
                    show={showAlert.show}
                    type={showAlert.type}
                    title={showAlert.title}
                    massage={showAlert.msg}
                    hideAlert={hideAlert} />
            }
            {popupData.show && popupData.type === 'refrence' ?
                <PopupModel
                    size='lg'
                    showModal={popupData.show}
                    handleCloseModal={handleCloseModal}
                    title={popupData.title}
                    type={popupData.type}

                >
                    <RefrenceList selectedItem={popupData.selectedItem} requestFrom={'course'} handelSave={handelSave} />
                </PopupModel> : null
            }
        </Col>
    );
}